import { render, staticRenderFns } from "./SendEmailSuccessModal.vue?vue&type=template&id=ffa400ce&scoped=true&"
import script from "./SendEmailSuccessModal.vue?vue&type=script&lang=js&"
export * from "./SendEmailSuccessModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa400ce",
  null
  
)

export default component.exports